import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material'

const ConfirmDeleteDialog = ({ open, onClose, onConfirm, title, message, isLoading }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title || 'Confirm Delete'}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {message || 'Are you sure you want to delete this item? This action cannot be undone.'}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          CANCEL
        </Button>
        <Button onClick={onConfirm} color='error' variant='contained' disabled={isLoading}>
          DELETE
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDeleteDialog
